<template>
    <section class="endpoint-section endpoint-http">
                    <pre class="endpoint-http-call">
                    <code class="endpoint-http-method">{{ methods.join(' | ') }}</code>
                    <code class="endpoint-http-uri">{{ uri }}</code>
                </pre>
    </section>
</template>

<script>
  export default {
    name: 'EndpointHttpCall',

    props: {
      methods: {
        type:     Array,
        required: true,
      },

      uri: {
        type:     String,
        required: true,
      },
    },
  };
</script>

<style scoped>
    .endpoint-http-call {
        display:       flex;
        flex-wrap:     wrap;
        white-space:   nowrap;
        font-size:     1.2rem;
        padding:       1rem;
        border-radius: 3px;
        background:    linear-gradient(60deg, rgba(96, 125, 139, 0.15), rgba(96, 125, 139, 0.25));
        color:         var(--color-gray-darker);
        text-shadow:   1px 1px rgba(255, 255, 255, 0.5);
        box-shadow:    inset 10px -10px 15px -15px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.115);
    }

    .endpoint-http-method {
        font-weight:    700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin-right:   1rem;
        user-select:    none;
    }
</style>
